import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../Components/Breadcrumb";
import { blogs } from "../Blog";

const sitemapGroups = [
  {
    title: "Company",
    links: [
      {
        name: "Home",
        url: "/",
      },
      {
        name: "About Us",
        url: "/about-us",
      },
      {
        name: "Contact",
        url: "/contact-us",
      },
    ],
  },

  {
    title: "Platform",
    links: [
      {
        name: "Features",
        url: "/features",
      },
       {
        name: "Industries",
        url: "/industries",
      },
      {
        name: "Pricing",
        url: "/pricing",
      },
    ],
  },
  {
    title: "Support & Information",
    links: [
      {
        name: "Book a Demo",
        url: "/book-a-demo",
      },
        {
        name: "Blog",
        url: "/blog",
      },
    ],
  },
  {
    title: "Legal",
    links: [
      {
        name: "Privacy Policy",
        url: "/privacy-policy",
      },
      {
        name: "Terms & Conditions",
        url: "/terms-conditions",
      },
      {
        name: "Cancellation & Refund",
        url: "/cancellation-refund",
      },
       {
        name: "Cookie Policy",
        url: "/cookie-policy",
      },
    ],
  },
];

const Sitemap = () => {
  useEffect(() => {
    document.title =
      "Sitemap | Onbbits WhatsApp Business Automation";

    const metaDesc = document.querySelector(
      "meta[name='description']"
    );

    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Explore the Onbbits sitemap to find WhatsApp automation features, solutions, pricing, tools, documentation, support and company information."
      );
    }

    const canonical = document.querySelector(
      "link[rel='canonical']"
    );

    if (canonical) {
      canonical.setAttribute(
        "href",
        "https://onbbits.io/sitemap"
      );
    }

    const ogTitle = document.querySelector(
      "meta[property='og:title']"
    );

    if (ogTitle) {
      ogTitle.setAttribute(
        "content",
        "Sitemap | Onbbits WhatsApp Business Automation"
      );
    }

    const ogDesc = document.querySelector(
      "meta[property='og:description']"
    );

    if (ogDesc) {
      ogDesc.setAttribute(
        "content",
        "Explore the Onbbits sitemap to find WhatsApp automation features, solutions, pricing, tools, documentation, support and company information."
      );
    }

    const ogUrl = document.querySelector(
      "meta[property='og:url']"
    );

    if (ogUrl) {
      ogUrl.setAttribute(
        "content",
        "https://onbbits.io/sitemap"
      );
    }

         const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://onbbits.io/Images/flow-builder.webp"
        );
      }


        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "Sitemap | Onbbits WhatsApp Business Automation"
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Explore the Onbbits sitemap to find WhatsApp automation features, solutions, pricing, tools, documentation, support and company information."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://onbbits.io/Images/flow-builder.webp"
        );
      }
  }, []);

  return (
    <>
      <Breadcrumb title="Sitemap" />

      <main className="sitemap-page">

        {/* INTRO */}
        <section className="sitemap-intro">
          <div className="container">

            <div className="sitemap-intro-inner">

              <h2 className="section-heading">
                Explore the <span>ONBBITS Sitemap</span>
              </h2>

              <p className="section-text">
                Find your way around ONBBITS. Explore our WhatsApp
                automation platform, business solutions, pricing,
                resources, tools, company information and support.
              </p>

            </div>

            <div className="sitemap-grid">

              {sitemapGroups.map((group, index) => {
                return (
                  <div
                    className="sitemap-group"
                    key={index}
                  >

                    {/* GROUP HEADER */}
                    <div className="sitemap-group-header">
                      <div>
                        <h3 className="card-heading">
                          {group.title}
                        </h3>
                      </div>

                    </div>


                    {/* LINKS */}
                    <div className="sitemap-links">

                      {group.links.map((link, linkIndex) => (
                        <Link
                          to={link.url}
                          className="sitemap-link"
                          key={linkIndex}
                        >

                            <p className="section-text">
                              {link.name}
                            </p>

                        </Link>
                      ))}

                    </div>

                  </div>
                );
              })}

            </div>

            {/* BLOGS */}
<div className="sitemap-grid sitemap-blog-grid">

  <div className="sitemap-group sitemap-blog-group">

    <div className="sitemap-group-header">
      <h3 className="card-heading">
        Blogs
      </h3>
    </div>

    <div className="sitemap-links">

      {blogs.map((blog, index) => (
        <Link
          to={`/blog/${blog.slug}`}
          className="sitemap-link"
          key={index}
        >
          <p className="section-text">
            {blog.title}
          </p>
        </Link>
      ))}

    </div>

  </div>

</div>
               </div>

        </section>
      </main>
    </>
  );
};

export default Sitemap;